import type {
  CancelSubscriptionRequest,
  CancelSubscriptionResponse,
  ListSubscriptionInvoicesResponse,
  ListSubscriptionOverageChargesResponse,
  SubscriptionResponse,
} from '@jq4race/shared';

import { request } from './client.js';

// ── Org Admin subscription visibility + cancellation — saas-monetization-plans v2 ──

/** GET /billing/subscription */
export async function getSubscription(): Promise<SubscriptionResponse> {
  return request<SubscriptionResponse>('/billing/subscription', { method: 'GET' });
}

/** GET /billing/subscription/invoices */
export async function listSubscriptionInvoices(): Promise<ListSubscriptionInvoicesResponse> {
  return request<ListSubscriptionInvoicesResponse>('/billing/subscription/invoices', {
    method: 'GET',
  });
}

/** GET /billing/subscription/overage-charges */
export async function listSubscriptionOverageCharges(): Promise<ListSubscriptionOverageChargesResponse> {
  return request<ListSubscriptionOverageChargesResponse>('/billing/subscription/overage-charges', {
    method: 'GET',
  });
}

/**
 * POST /billing/subscription/cancel
 * Legal-friction cancellation — `reason`/`retentionOfferAccepted` are both
 * OPTIONAL and never block the request (spec "Legal cancellation with
 * retention friction").
 */
export async function cancelSubscription(
  input: CancelSubscriptionRequest = {},
): Promise<CancelSubscriptionResponse> {
  return request<CancelSubscriptionResponse>('/billing/subscription/cancel', {
    method: 'POST',
    body: input,
  });
}
